<template>
	<div class="container">
		<top :currentComponent="currentComponent" @Select="Select" :topList="topList"></top>
		<component :is="currentComponent"></component>
	</div>
</template>
<script>
import top from "@/views/mechanism/children/top";
import allWater from './components/institutionalWalletChild/allWater'
export default {
	components: {
		top,
		allWater,
	},
	data() {
		return {
			topList: [{
				name: "全部流水",
				to: "allWater",
			},
			// {
			// 	name: "积分",
			// 	to: "暂无页面",
			// },
			// {
			// 	name: "优惠卷",
			// 	to: "暂无页面",
			// },
			// {
			// 	name: "商城",
			// 	to: "暂无页面",
			// },
			],
			currentComponent: 'allWater',
		}
	},
	methods: {
		Select(val) {
			this.currentComponent = val
		}
	},
	mounted() {
		let data = this.$route.query
		console.log(this.$route.query, '看看坎坎坷坷');
		let flag = this.topList.findIndex(n => n.to === data.currentComponent)
		if (JSON.stringify(data) !== '{}' && flag !== -1) {
			this.currentComponent = data.currentComponent
		}
	},
}
</script>

<style lang="scss" scoped>
.container {
	height: 8rem;
	width: 100%;
}
</style>
